import { put, takeLatest } from 'redux-saga/effects';
import { ProjectAPI } from 'api/project';
import { FetchStatus } from 'data/core';
import { getProjectById } from 'data/projects/actions';
import { saveTasks } from 'data/tasks/slice';
import { logger } from 'services';
function* getProjectByIdSaga({ payload }) {
    const { projectId, handleSuccess = ()=>{}, handleError = ()=>{} } = payload;
    try {
        if (projectId) {
            const project = yield ProjectAPI.getProjectDetails(projectId);
            const phases = project.projectPhases;
            let tasks = [];
            phases.map((p)=>{
                tasks = [
                    ...tasks,
                    ...p.tasks
                ];
                return p;
            });
            yield put(saveTasks({
                data: tasks,
                fetchStatus: FetchStatus.Partial
            }));
            handleSuccess();
        } else {
            throw new Error('Project ID not found');
        }
    } catch (error) {
        logger.error('getProjectDetails failed', {
            error
        });
        handleError();
    }
}
export const watchGetProjectByIdSaga = function*() {
    yield takeLatest(getProjectById.type, getProjectByIdSaga);
};
